import {
  fetch,
  normalize,
  extractHubURL,
} from '../../utils/dataAccess';
import { success as deleteSuccess } from './delete';
import {filterAction, sortAction} from "../../utils/filterAndSortUtils";

export function error(error) {
  return { type: 'INVITATION_INTERVIEW_STATUS_LIST_ERROR', error };
}

export function loading(loading) {
  return { type: 'INVITATION_INTERVIEW_STATUS_LIST_LOADING', loading };
}

export function success(retrieved) {
  return { type: 'INVITATION_INTERVIEW_STATUS_LIST_SUCCESS', retrieved };
}

export function list(page = 'invitation_interview_statuses') {
  return dispatch => {
    dispatch(loading(true));
    dispatch(error(''));

    fetch(page)
      .then(response =>
        ({ retrieved: response.data, hubURL: extractHubURL(response) })
      )
      .then(({ retrieved, hubURL }) => {
        retrieved = normalize(retrieved);

        dispatch(loading(false));
        dispatch(success(retrieved));
      })
      .catch(e => {
        dispatch(loading(false));
        dispatch(error(e.message));
      });
  };
}

export function reset(eventSource) {
  return dispatch => {
    if (eventSource) eventSource.close();

    dispatch({ type: 'INVITATION_INTERVIEW_STATUS_LIST_RESET' });
    dispatch(deleteSuccess(null));
  };
}

export function filter(filtersData) {
  return filterAction('INVITATION_INTERVIEW_STATUS_LIST_FILTER', 'invitation_interview_statuses', filtersData)
}

export function sort(sortData) {
  return sortAction('INVITATION_INTERVIEW_STATUS_LIST_SORT', 'invitation_interview_statuses', sortData)
}
